/** How long the browser may poll PDF jobs before giving up (generate flows). */
export const PDF_JOB_CLIENT_MAX_WAIT_MS = 15 * 60 * 1000;

export const PDF_JOB_CLIENT_POLL_INTERVAL_MS = 1500;
